import { render, staticRenderFns } from "./GroupProperties.vue?vue&type=template&id=2975b891&"
import script from "./GroupProperties.vue?vue&type=script&lang=js&"
export * from "./GroupProperties.vue?vue&type=script&lang=js&"
import style0 from "./GroupProperties.vue?vue&type=style&index=0&id=2975b891&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports